import React, { useEffect, useRef, useState } from 'react'
import { setRTLTextPlugin } from 'mapbox-gl'
import ReactMapboxGl, { Marker } from 'react-mapbox-gl'
import mapboxgl from 'mapbox-gl'
import 'mapbox-gl/dist/mapbox-gl.css'

setRTLTextPlugin(
  'https://www.parsimap.com/scripts/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.0/mapbox-gl-rtl-text.js'
)

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN

const Map = ReactMapboxGl({ accessToken: 'parsimap.accessToken' })

const styles = {
  width: '100%',
  height: '400px'
}

// var marker = new Marker()
//   .setLngLat([0, 0])
//   .addTo(Map);

export default function ParsiMap(props) {
  const mapContainerRef = useRef(null)

  useEffect(() => {
    const map = new mapboxgl.Map({
      container: mapContainerRef.current,
      style: 'https://www.parsimap.com/styles/street.json',
      center: [51.41, 35.7575],
      zoom: 8
    })

    map.addControl(new mapboxgl.NavigationControl(), 'bottom-right')

    map.addControl(
      new mapboxgl.GeolocateControl({
        positionOptions: {
          enableHighAccuracy: true
        },
        trackUserLocation: true
      })
    )

    map.addControl(
      new mapboxgl.AttributionControl({
        compact: true
      })
    )

    map.addControl(new mapboxgl.FullscreenControl())

    let marker = new mapboxgl.Marker().setLngLat([51.41, 35.7575]).addTo(map)

    map.on('movestart', function(e) {
      // console.log('dragstart');
      // console.log(`Current Map Center: ${map.getCenter()}`);
      marker.setLngLat(map.getCenter())
    })

    map.on('move', function(e) {
      // console.log('move');
      // console.log(`Current Map Center: ${map.getCenter()}`);
      marker.setLngLat(map.getCenter())
    })

    map.on('moveend', function(e) {
      props.onChange(map.getCenter().lat, map.getCenter().lng)
      marker.setLngLat(map.getCenter())
    })
  }, [])

  return (
    <div>
      <div ref={mapContainerRef} style={styles} />
    </div>
  )
}
